import { render, staticRenderFns } from "./ScrollableButtonList.vue?vue&type=template&id=aee4fd12&scoped=true&"
import script from "./ScrollableButtonList.vue?vue&type=script&lang=js&"
export * from "./ScrollableButtonList.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableButtonList.vue?vue&type=style&index=0&id=aee4fd12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee4fd12",
  null
  
)

export default component.exports